
import ContactsBlock from '@/components/TheMain/components/ContactsBlock';
import RoundedTableCYP2C19 from "~/components/TheMain/components/RoundedTableCYP2C19";
import CoolLightBox from "vue-cool-lightbox";
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css';
export default {
  name: 'Cyp2c19',
  components: { ContactsBlock,
    RoundedTableCYP2C19,
    CoolLightBox
  },
  data() {
    return {
      images: [
        {url: '/images/R2001_CYP2C19.jpg'}
      ],
      imageIndex: null,
      text: '        Ген <i>CYP2C19</i> кодирует изофермент системы цитохрома Р-450,\n' +
        '        отвечающий за биотрансформацию лекарственных средств и метаболизм\n' +
        '        эндогенных соединений. Однонуклеотидные замены <i>G681A</i> в\n' +
        '        <i>CYP2C19*2</i> и <i>G636A</i> в <i>CYP2C19*3</i> снижает\n' +
        '        каталитическую активность изофермента, а замена <i>C806T</i> в\n' +
        '        <i>CYP2C19*17</i> повышает ее. Изменение активности фермента нарушает\n' +
        '        метаболизм стероидных гормонов, жирных кислот, ретиноидов, желчных\n' +
        '        кислот, биогенных аминов, лейкотриенов и ксенобиотиков, антиагрегантов\n' +
        '        (клопидогрел), ингибиторов протонного насоса (омепразол, эзомепразол,\n' +
        '        лансопразол, пантопразол), антидепрессантов (амитриптилин, имипрамин,\n' +
        '        кломипрамин, циталопрам, доксепин, сертралин, дулоксетин, эсциталопрам,\n' +
        '        тримипрамин), противогрибковых ЛС (вориконазола) и др. веществ.',
    }
  },
  head() {
    return {
      title: 'ГенТест CYP2C19',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content:
            'Набор для выявления аллельных вариантов в гене человека CYP2C19 методом ПЦР-РВ',
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content:
            'ГенТест CYP2C19, R2001, тест система CYP2C19, kit CYP2C19, набор CYP2C19, мутация CYP2C19, горячая точка CYP2C19, аллельный вариант CYP2C19, скрининг CYP2C19, CYP2C19*2, NG_008384.2:g.24154G> A, rs4244285, NM_000769.2:c.681G> A, NP_000760.1:p.Pro227',
        },
      ],
    }
  },
}
